import { largeCurrencyFormat } from '../../formats/formats';

export const GPC_APPROACH_TYPE = 'Public Comps';
export const PUBLIC_COMPS_APPROACH = 'public_comps_approach_calibration';
export const MULTIPLE_TYPE_REVENUE_SELECTOR = 'revenue_premium_formula_selector';
export const MULTIPLE_TYPE_EBITDA_SELECTOR = 'ebitda_premium_formula_selector';
export const FINANCIALS_VERSION_CALIBRATION = 'financials_version';
export const performanceKeys = [
  'name',
  'enterprise_value',
  'ltm_revenue',
  'ltm_revenue_multiple',
  'ltm_revenue_growth',
  'ntm_revenue',
  'ntm_revenue_multiple',
  'ntm_revenue_growth',
  'ltm_ebitda',
  'ltm_ebitda_multiple',
  'ntm_ebitda',
  'ntm_ebitda_multiple',
  'gross_margin',
  'ebitda_margin',
  'tangible_book_value',
  'net_income_to_common_excl_extra_items',
  'cap_iq_id',
];
export const emptyFinancials = {
  ltm_adjusted_ebitda: 0,
  ltm_ebitda_margin: 0,
  ltm_ebitda: 0,
  ltm_gross_margin: 0,
  ltm_revenue_growth_rate: 0,
  ltm_revenue: 0,
  ntm_adjusted_ebitda: 0,
  ntm_ebitda: 0,
  ntm_revenue_growth_rate: 0,
  ntm_revenue: 0,
  total_cash_equivalents: 0,
  total_debt: 0,
  use_adjusted_ebitda: false,
  net_income: 0,
  assets_total: 0,
  intangibles: 0,
  liabilities_total: 0,
  id: 0,
  ltm_net_income: 0,
  ntm_net_income: 0,
  tangible_book_value: 0,
};

export const commonInputFields = {
  gridType: 'number',
  format: largeCurrencyFormat,
  ignoreRowCopy: true,
  isClassNameRequired: true,
  className: 'row-label-indented',
};

export const INPUTS_TABLE_ALIASES = {
  CALIBRATION_DATE: 'calibration_date',
  ENTERPRISE_VALUE_INPUTS: 'enterprise_value_inputs',
  EQUITY_VALUE_INPUTS: 'equity_value_inputs',
  LTM_REVENUE_INPUTS: 'ltm_revenue_inputs',
  NTM_REVENUE_INPUTS: 'ntm_revenue_inputs',
  LTM_EBITDA_INPUTS: 'ltm_ebitda_inputs',
  NTM_EBITDA_INPUTS: 'ntm_ebitda_inputs',
  FINANCIALS_VERSION: 'financials_version',
};

export const LTM_REVENUE_PREMIUM_ALIAS = 'ltm_revenue_multiple_premium_over_median';
export const NTM_REVENUE_PREMIUM_ALIAS = 'ntm_revenue_multiple_premium_over_median';
export const LTM_EBITDA_PREMIUM_ALIAS = 'ltm_ebitda_multiple_premium_over_median';
export const NTM_EBITDA_PREMIUM_ALIAS = 'ntm_ebitda_multiple_premium_over_median';

// Sister rows
export const ENTERPRISE_VALUE_ROW_NUMBER = 4;
export const EQUITY_VALUE_ROW_NUMBER = 7;
